import * as React from 'react'

import style from '../login.module.scss'

interface HoverTagProps {
  defaultText?: string
  hoverText?: string
}

const HoverTag: React.FC<HoverTagProps> = ({ defaultText, hoverText }) => {
  return (
    <div className={`${style.group} group min-w-[270px] right-0 absolute`}>
      <div
        className={`w-[273px] overflow-hidden
          text-black body-s font-extrabold italic group-hover:w-[227px]
          whitespace-nowrap ${style.tagWrap}`}
      >
        {/* Default Text */}
        <span
          className={`
            inline-block
            group-hover:hidden
            group-hover:opacity-0
            ease-linear duration-300
          `}
        >
          {defaultText}
        </span>

        {/* Hover Text */}
        <span
          className={`
            hidden opacity-0
            group-hover:inline-block 
            group-hover:opacity-100
            ease-linear duration-300`}
        >
          {hoverText}
        </span>
      </div>
    </div>
  )
}

export default HoverTag
